import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '@jg/alert';

type AlertProps = {
  isSuccess: boolean;
  isError: boolean;
};
export default ({ isError, isSuccess }: AlertProps) => {
  const { t } = useTranslation();
  if (isSuccess) {
    return (
      <Alert
        type="success"
        displayType="inline"
        className="jg-tc-alert-wrapper"
      >
        {t('global.alert.success')}
      </Alert>
    );
  }

  if (isError) {
    return (
      <Alert
        type="warning"
        displayType="inline"
        className="jg-tc-alert-wrapper"
      >
        {t('global.error.fatal')}
      </Alert>
    );
  }

  return null;
};
